// eslint-disable-next-line max-classes-per-file
import React, { Component } from "react";
import {
  Modal,
  Spin,
  Button,
  Upload,
  Typography,
  Form,
  Row,
  Col,
  Input,
  Menu,
  Dropdown,
  Avatar,
  Table,
  Checkbox,
} from "antd";
import {
  LoadingOutlined,
  PlusOutlined,
  EllipsisOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import * as Swal from "sweetalert2";
import styled from "styled-components";
import { DndProvider, DragSource, DropTarget } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { arrayMove } from "react-sortable-hoc";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ImgCrop from "antd-img-crop";
import { Layout } from "../../containers";
import { bannerApi } from "../../../apis";
import { userAction } from "../../../store/action";
import moment from "moment";
import "moment/locale/th";
import { refreshToken } from "../../utils/refreshToken";
// const { TextArea } = Input;
const { Text } = Typography;
const UploadStyle = styled(Upload)`
  .ant-upload.ant-upload-select-picture-card {
    width: 200px;
    height: 200px;
  }
`;

const { confirm } = Modal;
const dummyRequest = ({ file, onSuccess }) => {
  setTimeout(() => {
    console.log(file);
    onSuccess("ok");
  }, 0);
};
let dragingIndex = -1;
function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener("load", (e) => {
    const img = new Image();
    img.src = e.target.result;
    img.onload = () => {
      callback(reader.result);
    };
  });
  Swal.close();
  reader.readAsDataURL(img);
}
const beforeUpload = (file) => {
  const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
  const isLt512k = file.size / 1024 / 1024 < 0.512;
  if (!isLt512k) {
    Swal.close();
    Swal.fire({
      icon: "error",
      text: `Image must smaller than 512KB!`,
      timer: 1500,
      showConfirmButton: false,
    });
  }
  return isJpgOrPng && isLt512k;
};
class BodyRow extends Component {
  render() {
    const {
      isOver,
      connectDragSource,
      connectDropTarget,
      moveRow,
      ...restProps
    } = this.props;
    const style = { ...restProps.style, cursor: "move" };

    let { className } = restProps;
    if (isOver) {
      if (restProps.index > dragingIndex) {
        className += " drop-over-downward";
      }
      if (restProps.index < dragingIndex) {
        className += " drop-over-upward";
      }
    }

    return connectDragSource(
      connectDropTarget(
        <tr {...restProps} className={className} style={style} />,
      ),
    );
  }
}

const rowSource = {
  beginDrag(props) {
    dragingIndex = props.index;
    return {
      index: props.index,
    };
  },
};

const rowTarget = {
  drop(props, monitor) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return;
    }

    // Time to actually perform the action
    props.moveRow(dragIndex, hoverIndex).then();

    // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.
    monitor.getItem().index = hoverIndex;
  },
};

const DragableBodyRow = DropTarget("row", rowTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
}))(
  DragSource("row", rowSource, (connect) => ({
    connectDragSource: connect.dragSource(),
  }))(BodyRow),
);

class BannerHome extends Component {
  constructor(props) {
    super(props);
    this.components = {
      body: {
        row: DragableBodyRow,
      },
    };
    this.myFormRef = React.createRef();
    this.editFormRef = React.createRef();
    this.state = {
      // items: [],
      loading: true,
      visible: false,
      data: [],
      isCheck: false,
      isEditCheck: false,
      editVisble: false,
      check_token: false,
    };
  }

  componentDidMount = () => {
    this.checkToken();
  };

  componentWillUnmount() {
    clearInterval(this.timeout);
  }

  checkToken = async () => {
    const now = moment().unix();
    if (now >= localStorage.getItem("exp_access_token")) {
      const check = await refreshToken();
      if (check) {
        this.timeout = setTimeout(() => {
          this.fetchData();
        }, 1);
      } else {
        window.location.href = "/";
      }
    } else {
      this.fetchData();
    }
  };

  fetchData = async () => {
    this.setState({
      check_token: true,
    });
    bannerApi
      .bannerHomeTable()
      .then((resp) => {
        this.setState({
          data: resp.data,
          loading: false,
        });
      })
      .catch((error) => {
        this.setState({ loading: false });
        throw error;
      });
  };

  handleChangePhoto = async (info) => {
    if (info.file.status === "uploading") {
      return;
    }
    if (info.file.status === "done") {
      await getBase64(info.file.originFileObj, (imageUrl) => {
        this.setState({
          imageUrl,
          loading: false,
          imageFile: info.file.originFileObj,
        });
      });
    }
  };

  handleCancel = () => {
    this.setState({
      visible: false,
      editVisble: false,
    });
  };

  onFinish = (values) => {
    const formData = new FormData();
    formData.append("name", values.name || "");
    formData.append("short_description", values.description || "");
    formData.append("type", this.state.isCheck ? 1 : 0);
    this.state.isCheck && formData.append("text_button", values.textBtn || "");
    this.state.isCheck && formData.append("url", values.urlBtn || "");
    formData.append("image", this.state.imageFile);
    this.myFormRef.current.resetFields();
    Swal.fire({
      title: "ต้องการสร้างข้อมูล Banner Home ใช่หรือไม่",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#0c7973",
      confirmButtonText: "ยืนยัน",
      cancelButtonText: "ยกเลิก",
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: "ระบบกำลังทำงาน",
          allowEscapeKey: false,
          allowOutsideClick: false,
          showConfirmButton: false,
          onOpen: () => {
            Swal.showLoading();
          },
        });
        bannerApi
          .createBannerHome(formData)
          .then((resp) => {
            Swal.fire({
              icon: "success",
              title: `${resp.message}`,
              timer: 1500,
              showConfirmButton: false,
            }).then(() => {
              this.setState({
                visible: false,
                imageUrl: null,
                imageFile: null,
              });
              this.componentDidMount();
            });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: `${error.response.data.message}`,
              showConfirmButton: false,
            });
          });
      }
    });
  };

  onEditFinish = (values) => {
    const formData = new FormData();
    formData.append("name", values.name || "");
    formData.append("short_description", values.description || "");
    formData.append("type", this.state.isEditCheck ? 1 : 0);
    this.state.isEditCheck &&
      formData.append("text_button", values.textBtn || "");
    this.state.isEditCheck && formData.append("url", values.urlBtn || "");
    formData.append("image", this.state.imageFile);
    Swal.fire({
      title: "ต้องการแก้ไขข้อมูล Banner Home ใช่หรือไม่",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#0c7973",
      confirmButtonText: "ยืนยัน",
      cancelButtonText: "ยกเลิก",
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: "ระบบกำลังทำงาน",
          allowEscapeKey: false,
          allowOutsideClick: false,
          showConfirmButton: false,
          onOpen: () => {
            Swal.showLoading();
          },
        });
        bannerApi
          .updateBannerHome(formData, this.state.id)
          .then((resp) => {
            Swal.fire({
              icon: "success",
              title: `${resp.message}`,
              timer: 1500,
              showConfirmButton: false,
            }).then(() => {
              this.setState({
                editVisble: false,
                imageUrl: null,
                imageFile: null,
              });
              this.componentDidMount();
            });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: `${error.response.data.message}`,
              showConfirmButton: false,
            });
          });
      }
    });
  };

  onChangeCheck = (e) => {
    this.setState({
      isCheck: e.target.checked,
    });
  };

  onChangeEditCheck = (e) => {
    this.setState({
      isEditCheck: e.target.checked,
    });
  };

  moveRow = async (oldIndex, newIndex) => {
    await this.setState({
      data: arrayMove(this.state.data, oldIndex, newIndex),
    });
    const list = [];
    for (let i = 0; i < this.state.data.length; i += 1) {
      list.push({
        id: this.state.data[i].id,
        index: i + 1,
      });
    }
    bannerApi.indexBannerHome({ obj: list }).catch((error) => {
      throw error;
    });
  };

  onEdit = (id) => {
    bannerApi
      .getBannerHome(id)
      .then(async (resp) => {
        this.setState({
          id: resp.data.id,
          name: resp.data.name,
          description: resp.data.short_description,
          textBtn: resp.data.text_button,
          urlBtn: resp.data.url,
          imageUrl: resp.data.image,
          isEditCheck: resp.data.type === 0 ? false : true,
          editVisble: true,
        });
        this.editFormRef.current.setFieldsValue({
          name: resp.data.name,
          description: resp.data.short_description,
          textBtn: resp.data.text_button,
          urlBtn: resp.data.url,
        });
      })
      .catch((error) => {
        this.setState({ loading: false });
        throw error;
      });
  };

  render() {
    const menus = this.props.menu;
    // type 1 = read, 2 = create, 3 = update, 4 = delete
    const isCreate = [];
    const isEdit = [];
    const isDelete = [];
    menus &&
      menus[4].actions.forEach((doc) => {
        if (doc.type === 2 && doc.status === 1) {
          isCreate.push(1);
        } else if (doc.type === 3 && doc.status === 1) {
          isEdit.push(1);
        } else if (doc.type === 4 && doc.status === 1) {
          isDelete.push(1);
        }
      });
    const { loading, imageUrl, data, isCheck, check_token } = this.state;
    const uploadButton = (
      <div>
        {loading ? <LoadingOutlined /> : <PlusOutlined />}
        <div style={{ marginTop: 8 }}>Upload</div>
      </div>
    );
    const menu = (record) => (
      <Menu className="datable-actions-menu">
        {isEdit[0] === 1 && (
          <Menu.Item>
            <Link to="/banner-home" onClick={() => this.onEdit(record.id)}>
              Edit
            </Link>
          </Menu.Item>
        )}
        {isDelete[0] === 1 && (
          <Menu.Item>
            <Link
              to="/banner-home"
              onClick={() => {
                confirm({
                  title: "ต้องการลบข้อมูลใช่หรือไม่?",
                  centered: true,
                  icon: <ExclamationCircleOutlined />,
                  onOk: () => {
                    Swal.fire({
                      title: "ระบบกำลังทำงาน",
                      allowEscapeKey: false,
                      allowOutsideClick: false,
                      showConfirmButton: false,
                      onOpen: () => {
                        Swal.showLoading();
                      },
                    });
                    bannerApi
                      .deleteBannerHome(record.id)
                      .then((resp) => {
                        Swal.fire({
                          icon: "success",
                          title: `${resp.message}`,
                          timer: 1500,
                          showConfirmButton: false,
                        }).then(() => {
                          this.componentDidMount();
                        });
                      })
                      .catch((error) => {
                        Swal.fire({
                          icon: "error",
                          title: `${error.response.data.message}`,
                          showConfirmButton: false,
                        });
                      });
                  },
                });
              }}
            >
              Delete
            </Link>
          </Menu.Item>
        )}
      </Menu>
    );

    const columns = [
      {
        title: "Name",
        dataIndex: "name",
        id: "name",
        type: "input",
        render: (text) => <span>{text}</span>,
      },
      {
        title: "Short Description",
        dataIndex: "short_description",
        key: "short_description",
        width: "50%",
        render: (text) => <span>{text}</span>,
      },
      {
        title: "Image",
        dataIndex: "image",
        key: "image",
        type: "text",
        render: (text) => <Avatar shape="square" size={64} src={text} />,
      },
      {
        title: "Index",
        dataIndex: "index",
        id: "index",
        align: "right",
        type: "input",
        width: "50px",
        render: (text, record, index) => <span>{index + 1}</span>,
      },
      {
        title: "Action",
        key: "action",
        align: "right",
        render: (text, record) => (
          <Dropdown
            trigger={["click"]}
            overlay={menu(record)}
            placement="bottomRight"
          >
            <Button type="link">
              <EllipsisOutlined />
            </Button>
          </Dropdown>
        ),
      },
    ];
    return (
      <>
        {check_token === true && (
          <Layout
            title="Home Banner"
            extraBtn={
              isCreate[0] === 1
                ? [
                    <Button
                      disabled={loading}
                      type="primary"
                      onClick={async () => {
                        await this.setState({
                          imageUrl: null,
                          imageFile: null,
                          isCheck: false,
                          visible: true,
                        });
                        this.myFormRef.current.resetFields();
                      }}
                    >
                      + Add banner
                    </Button>,
                  ]
                : []
            }
            breadcrumbNav={[
              {
                path: "dashboard",
                breadcrumbName: "Dashboard",
              },
              {
                path: "banner-home",
                breadcrumbName: "Home Banner",
              },
            ]}
          >
            <Spin spinning={loading} tip="Loading...">
              {loading === false && (
                <DndProvider backend={HTML5Backend}>
                  <Table
                    className="mt-4"
                    rowKey={(record) => record.id}
                    columns={columns}
                    dataSource={data}
                    components={this.components}
                    onRow={(record, index) => ({
                      index,
                      moveRow: this.moveRow,
                    })}
                  />
                </DndProvider>
              )}
            </Spin>
            <Modal
              title="Add banner"
              visible={this.state.visible}
              onOk={this.handleCancel}
              onCancel={this.handleCancel}
              footer={null}
              centered
              width={800}
            >
              <Form
                ref={this.myFormRef}
                layout="vertical"
                onFinish={this.onFinish}
              >
                <Row>
                  <Col span={8}>
                    <Text>image</Text>
                    <Form.Item
                      className="mt-4"
                      extra={
                        <ul>
                          <li>Max file size 512Kb.</li>
                          <li>Image with .jpg, .jpeg and .png</li>
                          <li>ขนาดรูปที่แนะนำ 1920*1080px</li>
                        </ul>
                      }
                    >
                      <ImgCrop aspect={16 / 9}>
                        <UploadStyle
                          accept=".jpg, .jpeg, .png"
                          name="avartar"
                          customRequest={dummyRequest}
                          listType="picture-card"
                          multiple={false}
                          showUploadList={false}
                          beforeUpload={beforeUpload}
                          onChange={this.handleChangePhoto}
                          onPreview={this.onPreview}
                          required
                        >
                          {imageUrl ? (
                            <img width="100%" src={imageUrl} alt="avatar" />
                          ) : (
                            uploadButton
                          )}
                        </UploadStyle>
                      </ImgCrop>
                    </Form.Item>

                    <Form.Item className="my-3">
                      <Row>
                        <Col span={24}>
                          <Button type="primary" htmlType="submit">
                            Submit
                          </Button>
                          <Button
                            className="mx-4"
                            onClick={() => this.setState({ visible: false })}
                          >
                            Cancel
                          </Button>
                        </Col>
                      </Row>
                    </Form.Item>
                  </Col>
                  <Col span={16}>
                    <Form.Item label="Name" name="name" type="text">
                      <Input />
                    </Form.Item>
                    <Form.Item
                      label="Short Description"
                      name="description"
                      type="text"
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item>
                      <Checkbox onChange={this.onChangeCheck}>
                        มีปุ่มไหม?
                      </Checkbox>
                    </Form.Item>
                    {isCheck ? (
                      <>
                        <Form.Item
                          label="Text button"
                          name="textBtn"
                          type="text"
                        >
                          <Input />
                        </Form.Item>
                        <Form.Item label="Url button" name="urlBtn" type="text">
                          <Input />
                        </Form.Item>
                      </>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
              </Form>
            </Modal>
            <Modal
              title="Edit banner"
              visible={this.state.editVisble}
              onOk={this.handleCancel}
              onCancel={this.handleCancel}
              footer={null}
              centered
              width={800}
            >
              <Form
                layout="vertical"
                onFinish={this.onEditFinish}
                ref={this.editFormRef}
                initialValues={{
                  name: this.state.name,
                  description: this.state.description,
                  textBtn: this.state.textBtn,
                  urlBtn: this.state.urlBtn,
                }}
              >
                <Row>
                  <Col span={8}>
                    <Text>image</Text>
                    <Form.Item
                      className="mt-4"
                      extra={
                        <ul>
                          <li>Max file size 512Kb.</li>
                          <li>Resolution 1920 x 1080 pixel</li>
                          <li>Image with .jpg, .jpeg and .png</li>
                        </ul>
                      }
                    >
                      <ImgCrop aspect={16 / 9}>
                        <UploadStyle
                          accept=".jpg, .jpeg, .png"
                          name="avartar"
                          customRequest={dummyRequest}
                          listType="picture-card"
                          multiple={false}
                          showUploadList={false}
                          beforeUpload={beforeUpload}
                          onChange={this.handleChangePhoto}
                          onPreview={this.onPreview}
                          required
                        >
                          {imageUrl ? (
                            <img width="100%" src={imageUrl} alt="avatar" />
                          ) : (
                            uploadButton
                          )}
                        </UploadStyle>
                      </ImgCrop>
                    </Form.Item>

                    <Form.Item className="my-3">
                      <Row>
                        <Col span={24}>
                          <Button type="primary" htmlType="submit">
                            Submit
                          </Button>
                          <Button
                            className="mx-4"
                            onClick={() => this.setState({ editVisble: false })}
                          >
                            Cancel
                          </Button>
                        </Col>
                      </Row>
                    </Form.Item>
                  </Col>
                  <Col span={16}>
                    <Form.Item label="Name" name="name" type="text">
                      <Input />
                    </Form.Item>
                    <Form.Item
                      label="Short Description"
                      name="description"
                      type="text"
                    >
                      <Input />
                    </Form.Item>
                    {this.state.isEditCheck === true ? (
                      <Form.Item>
                        <Checkbox checked onChange={this.onChangeEditCheck}>
                          มีปุ่มไหม?
                        </Checkbox>
                      </Form.Item>
                    ) : (
                      <Form.Item>
                        <Checkbox
                          checked={false}
                          onChange={this.onChangeEditCheck}
                        >
                          มีปุ่มไหม?
                        </Checkbox>
                      </Form.Item>
                    )}
                    {this.state.isEditCheck ? (
                      <>
                        <Form.Item
                          label="Text button"
                          name="textBtn"
                          type="text"
                        >
                          <Input />
                        </Form.Item>
                        <Form.Item label="Url button" name="urlBtn" type="text">
                          <Input />
                        </Form.Item>
                      </>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
              </Form>
            </Modal>
          </Layout>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  menu: state.menus.menu,
});

const mapDispatchToProps = (dispatch) => ({
  userAction: bindActionCreators(userAction, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(BannerHome);
